import { render, staticRenderFns } from "./GoPagesV2Wizard.vue?vue&type=template&id=156561cd&scoped=true"
import script from "./GoPagesV2Wizard.vue?vue&type=script&lang=js"
export * from "./GoPagesV2Wizard.vue?vue&type=script&lang=js"
import style0 from "./GoPagesV2Wizard.vue?vue&type=style&index=0&id=156561cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156561cd",
  null
  
)

export default component.exports